"use client";
import { useRef } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import toast from "react-hot-toast";

export const ContactUsForm = () => {
	const formik = useFormik({
		initialValues: {
			fullName: "",
			email: "",
			phone: "",
			inquiryType: "",
			message: "",
		},
		onSubmit: async (values, { setSubmitting, resetForm }) => {
			const res = await fetch(`${process.env.NEXT_PUBLIC_LIVE_URL}/api/contact`,
				{
					method: "POST",
					headers: { "Content-Type": "application/json", },
					body: JSON.stringify(values),
				}
			);
			if (res.status === 201) {
				toast.success("Success message");
				resetForm();
			} else {
				toast.error("Something went wrong. Please try again");
			}
		},
		validationSchema: yup.object({
			email: yup.string().email("Must be a valid email").required("This field is required"),
			fullName: yup.string().required("This field is required"),
			phone: yup.string(),
			inquiryType: yup.string(),
			message: yup.string().required("This field is required"),
		}),
	});

	return (
		<>
			<form onSubmit={formik.handleSubmit} className="py-6">
				<div className="input-wrapper">
					<input id="fullName" type="text" className={`input ${formik.touched.fullName && formik.errors.fullName && "error-input"}`}{...formik.getFieldProps("fullName")} placeholder="Full Name*" />
					{formik.touched.fullName && formik.errors.fullName ? (<div className="error-text">{formik.errors.fullName}</div>) : null}
				</div>

				<div className="input-wrapper">
					<input id="email" type="email" className={`input ${formik.touched.email && formik.errors.email && "error-input"}`}{...formik.getFieldProps("email")} placeholder="Email*" />
					{formik.touched.email && formik.errors.email ? (<div className="error-text">{formik.errors.email}</div>) : null}
				</div>

				<div className="input-wrapper">
					<input id="phone" type="text" className={`input ${formik.touched.phone && formik.errors.phone && "error-input"}`}{...formik.getFieldProps("phone")} placeholder="Phone" />
					{formik.touched.phone && formik.errors.phone ? (<div className="error-text">{formik.errors.phone}</div>) : null}
				</div>

				<div className="input-wrapper">
					<input id="inquiryType" type="text" className={`input ${formik.touched.inquiryType && formik.errors.inquiryType && "error-input"}`}{...formik.getFieldProps("inquiryType")} placeholder="Subject" />
					{formik.touched.inquiryType && formik.errors.inquiryType ? (<div className="error-text">{formik.errors.inquiryType}</div>) : null}
				</div>

				<div className="input-wrapper">
					<textarea id="message" type="text" className={`input ${formik.touched.message && formik.errors.message && "error-input"}`}{...formik.getFieldProps("message")} placeholder="Message*"></textarea>
					{formik.touched.message && formik.errors.message ? (<div className="error-text">{formik.errors.message}</div>) : null}
				</div>

				<div className="">
					<button type="submit" className="submit submit--full" disabled={formik.isSubmitting}>
						{!formik.isSubmitting ? (<span>Submit</span>) : ("Submitting..")}
						{formik.isSubmitting ? (<span>{/* <Loader size="small" /> */}</span>) : ("")}
					</button>
				</div>
			</form>
		</>
	);
};

// "use client";
// import { useRef } from "react";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import toast from "react-hot-toast";

// export const ContactUsForm = () => {
// 	const formik = useFormik({
// 		initialValues: {
// 			fullName: "",
// 			email: "",
// 			phone: "",
// 			inquiryType: "",
// 			message: "",
// 		},
// 		onSubmit: async (values, { setSubmitting, resetForm }) => {
// 			const res = await fetch(`${process.env.NEXT_PUBLIC_LIVE_URL}/api/contact`,
// 				{
// 					method: "POST",
// 					headers: { "Content-Type": "application/json", },
// 					body: JSON.stringify(values),
// 				}
// 			);
// 			if (res.status === 201) {
// 				toast.success("Success message");
// 				setSubmitting(true);
// 				resetForm();
// 			} else {
// 				toast.error("Something went wrong. Please try again");
// 			}
// 		},
// 		validationSchema: yup.object({
// 			email: yup.string().email("Must be a valid email").required("This field is required"),
// 			fullName: yup.string().required("This field is required"),
// 			phone: yup.string().required("This field is required"),
// 			inquiryType: yup.string().required("This field is required"),
// 			message: yup.string().required("This field is required"),
// 		}),
// 	});

// 	return (
// 		<>
// 			<form onSubmit={formik.handleSubmit} className="py-6">
// 				<div className="input-wrapper">
// 					<input id="inquiryType" type="text" className={`input ${formik.touched.inquiryType && formik.errors.inquiryType && "error-input"}`}{...formik.getFieldProps("inquiryType")} placeholder="Subject*" />
// 					{formik.touched.inquiryType && formik.errors.inquiryType ? (<div className="error-text">{formik.errors.inquiryType}</div>) : null}
// 				</div>

// 				<div className="input-wrapper">
// 					<input id="fullName" type="text" className={`input ${formik.touched.fullName && formik.errors.fullName && "error-input"}`}{...formik.getFieldProps("fullName")} placeholder="Full Name*" />
// 					{formik.touched.fullName && formik.errors.fullName ? (<div className="error-text">{formik.errors.fullName}</div>) : null}
// 				</div>

// 				<div className="input-wrapper">
// 					<input id="email" type="email" className={`input ${formik.touched.email && formik.errors.email && "error-input"}`}{...formik.getFieldProps("email")} placeholder="Email*" />
// 					{formik.touched.email && formik.errors.email ? (<div className="error-text">{formik.errors.email}</div>) : null}
// 				</div>

// 				<div className="input-wrapper">
// 					<input id="phone" type="text" className={`input ${formik.touched.phone && formik.errors.phone && "error-input"}`}{...formik.getFieldProps("phone")} placeholder="Phone*" />
// 					{formik.touched.phone && formik.errors.phone ? (<div className="error-text">{formik.errors.phone}</div>) : null}
// 				</div>

// 				<div className="input-wrapper">
// 					<textarea id="message" type="text" className={`input ${formik.touched.message && formik.errors.message && "error-input"}`}{...formik.getFieldProps("message")} placeholder="Message*"></textarea>
// 					{formik.touched.message && formik.errors.message ? (<div className="error-text">{formik.errors.message}</div>) : null}
// 				</div>

// 				<div className="">
// 					<button type="submit" className={`submit submit--full  ${formik.isValid && formik.dirty ? "" : "submit--disabled"}`} disabled={!(formik.isValid && formik.dirty)}>
// 						{!formik.isSubmitting ? (<span>Submit</span>) : ("Submitting..")}
// 						{formik.isSubmitting ? (<span><Loader size="small" /></span>) : ("")}
// 					</button>
// 				</div>
// 			</form>
// 		</>
// 	);
// };
